import React, { useEffect } from "react";
import Header from "../../components/header";
import "./trustpage.css";
import HomeVideo from "../../assets/trust_background.webp";
import Partnerships from "./partnerships";
import BlueParagraph from "./blueParagraph";
import TrustHightlightCharts from "./trust-hightlight-charts";
import { ParallaxProvider } from "react-scroll-parallax";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import Tpage from "./unsdg";
import FeatureStories from "./feature-stories";

export default function Homepage() {

  const handleScrollToNext = () => {
    const nextSection = document.getElementById("trust-our-choices");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ParallaxProvider>
      <div className="screen-page">
        <Header />
        {/* section 01 */}
        <div style={{ position: "relative" }}>
          <div className="home-page-video">
            <div>
              <img
                src={HomeVideo}
                style={{ height: "calc(100vh - 120px)", width: "100%", objectFit: "cover" }}
                alt=""
              />
            </div>
          </div>

          {/* <div style={{ marginLeft: "20px" }}>
            <div className="trust-video-text-box">
              <div className="video-background-text">
                <Parallax speed={10}>
                  <h1 className="trust-topic-home">Trust</h1>
                </Parallax>
              </div>
            </div>
          </div> */}

          {/* White Box */}
          <div className="white-box">
            <div className="white-box-container">
              {/* <h1>
                Modern <span className="white-box-container-h1">& Unique</span>
              </h1> */}
              <div className="screen-pc">
                <h1 className="white-box-container-h1-text">
                Trust <br />
                  {/* <span className="white-box-container-h1">Apparel Solutions</span> */}
                </h1>
              </div>

              <div className="screen-mobile">
                <p className="white-box-container-h1-text">
                Trust <br />
                  {/* <span className="white-box-container-h1">
                    Apparel <br />
                    Solutions
                  </span> */}
                </p>
              </div>

              {/* Button to scroll to the next section */}
              <div onClick={handleScrollToNext} className="scroll-button">
                <FontAwesomeIcon icon={faArrowDown} style={{ fontSize: "16px" }} />
              </div>
            </div>
          </div>

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "calc(100vh - 120px)",
              backgroundColor: "rgba(0, 0, 0, 0.15)",
              zIndex: 0,
            }}
          ></div>

          {/* H Letter Design */}
          <div className="h-banner-container">
            {/* Left Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-left"></div>
            </div>

            {/* Middle Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-design-N">
                <div className="h-left-N"></div>
                <div style={{ height: "350px" }} />
                <div className="h-right-N"></div>
              </div>
            </div>

            {/* Right Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-right"></div>
            </div>
          </div>

        </div>

        {/* section-2 */}
        <BlueParagraph />

        {/* section-4 */}
        <TrustHightlightCharts />

        {/* section-5 */}
        <Partnerships />

        <Tpage />

        <FeatureStories />
      </div>
    </ParallaxProvider>
  );
}
